const PATH = {
  QUICK_HOOK: 'quick-hook',
};

export default {
  PATH,
};
